import "bootstrap/dist/css/bootstrap.min.css";
import ChatbotButton from "../../components/common/ChatbotButton";
import "../../assets/styles/Sports.css";
import { useContext, useEffect, useState } from "react";
import { showAcademicActivities } from "../../services/activityService.js";
import { AuthContext } from "../../context/AuthContext.js";
import ActivityCard from "../../components/ui/newActivityCard.js";
import FullPageLoader from "../../components/ui/fullPageLoader.js";

export default function Sports() {
  const { loading, user } = useContext(AuthContext);
  const [sportsActivities, setSportsActivities] = useState([]);
  const [loadingApi, setLoadingApi] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoadingApi(true);
        const res = await showAcademicActivities();
        setSportsActivities(res.activities || []);
        setLoadingApi(false);
      } catch (error) {
        setLoadingApi(false);
        console.error("Error fetching activities:", error);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return <FullPageLoader loadingName="Loading user..." />;
  }

  return (
    <div
      className="sports-container container py-5"
      style={{ marginTop: "50px" }}
    >
      {/* Activities Section */}
      <div className="container py-5">
        <div className="text-center mb-5">
          <h1 className="fw-bold text-primary mb-2">Academic Activities</h1>
          <p className="text-secondary">
            Explore and join workshops, lectures, and academic events
          </p>
        </div>

        <div className="row justify-content-center g-4">
          {loadingApi && (
            <FullPageLoader loadingName="Loading available activities..." />
          )}

          {/* رسالة في حالة عدم وجود أنشطة */}
          {!loadingApi && sportsActivities.length === 0 && (
            <div className="col-12 text-center">
              <p className="text-danger">
                No entertainment activities available at the moment. Please
                check back later.
              </p>
            </div>
          )}

          {!loadingApi &&
            sportsActivities.map((activity) => (
              <div key={activity._id} className="col-12 col-md-6 col-lg-4">
                <ActivityCard
                  _id={activity?._id}
                  activityName={activity?.activityName}
                  posterImage={activity?.posterImage}
                  capacity={activity?.capacity}
                  participantsCount={activity?.participantsCount}
                  supervisorID={activity?.supervisorID}
                  participants={activity?.participants}
                  currentUserId={user?._id}
                  role={user?.role}
                  flags={activity?.flags}
                  type={activity?.type}
                />
              </div>
            ))}
        </div>
      </div>

      <ChatbotButton />
    </div>
  );
}
